<template>
    <div class="header-2025">
    <template v-if="props.data.showVideo">
      <div class="headerMask"></div>
      <video
        class="headerVideo"
        poster="https://p3.ssl.qhimg.com/t015ec4b9b0b2dea4e0.png"
        autoplay
        muted
        loop
      >
        <source src="https://isc.360kan.com/vod-isc-vod-101240-beijing/TL730b7df625e5454f3cb3ccd3878c4fdc.mp4" type="video/mp4" />
        您的浏览器不支持 video 标签。
      </video>
      <div class="headerContent">
        <!-- <img class="headerContentTitle" src="https://p4.ssl.qhimg.com/t110b9a9301803b00e3360d5fb7.png" alt="ISC.AI 2025" />
        <div class="headerContentDesc">第十三届互联网安全大会</div>
        <div class="headerContentInfo">2025年12月15-17日 · 北京国家会议中心</div> -->
        <img class="headerContentTitle" src="https://p4.ssl.qhimg.com/t110b9a9301f515a9b8e83f580b.png" alt="ISC.AI 2025" />
      </div>
    </template>
    <template v-else>
      <img class="bg-img" :src="props.data.bgUrl" alt="ISC.AI 2025" />
    </template>
  </div>
</template>
  
<script setup>
import { ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})
  
</script>
  
<style lang="scss" scoped>
  .header-2025 {
    position: relative;
    width: 100%;
    height: 100%;
    margin-top: 60px;
    .bg-img{
      width: 100%;
    }
    .headerVideo {
    //   width: 100%;
      height: 400px;
    }
    .headerMask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 5px);
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 1;
    }
   .headerContent {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 2;
      margin-top: -40px;
      &Title {
        width: 322px;
      }
      &Desc {
        color: rgb(255, 255, 255);
        font-family: HarmonyOS Sans;
        font-size: 30px;
        font-weight: 700;
        line-height: 38px;
        letter-spacing: 0px;
        text-align: left;
        text-transform: uppercase;
        margin-top: 12px;
      }
      &Info { 
        color: rgb(255, 255, 255);
        font-family: HarmonyOS Sans;
        font-size: 10px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 5px;
        text-align: justify;
        text-transform: uppercase;
        margin-top: 12px;
      }
   }
  }
</style>
  